define('GameDayCore/GDModel/ValueObjects/Linescore/LinescoreItem',['require','exports','module','../ValueObjectFactory'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory');

	VO.create(LinescoreItem);

	function LinescoreItem($data, $inning, $status_ind) {
		var vo = VO.ensureVO(this, LinescoreItem),
			data = $data || {},
			filler = $status_ind == "F" ? 'x' : '';
		vo.num=vo.inning = data.inning || $inning || "";
        vo.home = data.home_inning_runs || data.home || filler;
        vo.away = data.away_inning_runs || data.away || filler;
	}

	return LinescoreItem;
});
